import React, { useEffect, useState } from "react";

import { postOverleafSsoToken } from "utils/request/auth";

function getSafeReturnTo() {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get("return_to");

    return returnTo && returnTo.startsWith("/") ? returnTo : undefined;
}

function SSOPage() {
    const [message, setMessage] = useState("Signing you in to Overleaf...");

    useEffect(() => {
        const run = async () => {
            const accessToken = localStorage.getItem("token");
            if (!accessToken) {
                setMessage("Prep login is required.");
                window.location.replace("/login");
                return;
            }

            const returnTo = getSafeReturnTo();
            const data = await postOverleafSsoToken({ return_to: returnTo });

            const callbackUrl = new URL(data.overleaf_sso_callback_url);
            callbackUrl.searchParams.set("token", data.bridge_token);
            if (returnTo) {
                callbackUrl.searchParams.set("return_to", returnTo);
            }

            window.location.replace(callbackUrl.toString());
        };

        run().catch(() => {
            setMessage("Prep could not complete Overleaf SSO.");
        });
    }, []);

    return <div>{message}</div>;
}

export default SSOPage;
